import { Controller } from "@hotwired/stimulus"

// Filters a moments feed in the browser: by kind, adventure node (DM only),
// hidden-only (DM only) and free text. Live-appended moments are filtered too,
// via a MutationObserver. Nothing is removed from the DOM, only hidden.
export default class extends Controller {
  static targets = ["list", "kind", "node", "hiddenOnly", "search", "count"]
  static values = { nodes: Object }

  connect() {
    this.observer = new MutationObserver(() => this.apply())
    if (this.hasListTarget) this.observer.observe(this.listTarget, { childList: true })
    this.apply()
  }

  disconnect() {
    if (this.observer) this.observer.disconnect()
  }

  toggleKind(event) {
    const button = event.currentTarget
    button.setAttribute("aria-pressed", button.getAttribute("aria-pressed") === "true" ? "false" : "true")
    this.apply()
  }

  apply() {
    if (!this.hasListTarget) return

    const kinds = new Set(this.kindTargets
      .filter((b) => b.getAttribute("aria-pressed") === "true")
      .map((b) => b.dataset.kind))
    const node = this.hasNodeTarget ? this.nodeTarget.value : ""
    const hiddenOnly = this.hasHiddenOnlyTarget && this.hiddenOnlyTarget.checked
    const query = this.hasSearchTarget ? this.searchTarget.value.trim().toLowerCase() : ""

    let shown = 0
    const moments = this.listTarget.querySelectorAll("[data-moment]")
    moments.forEach((el) => {
      this.labelNode(el)
      const nodeId = el.dataset.nodeId || ""
      const visible =
        kinds.has(el.dataset.kind) &&
        (node === "" || (node === "none" ? nodeId === "" : nodeId === node)) &&
        (!hiddenOnly || el.dataset.hidden === "true") &&
        (query === "" || el.textContent.toLowerCase().includes(query))
      el.hidden = !visible
      if (visible) shown += 1
    })

    if (this.hasCountTarget) {
      this.countTarget.textContent = shown === moments.length ? "" : `${shown} of ${moments.length}`
    }
  }

  // Fills the DM-only node badge from the id -> name map (DM page only, so
  // player pages never carry node names).
  labelNode(el) {
    const badge = el.querySelector("[data-node-badge]")
    if (!badge) return
    const name = this.nodesValue[el.dataset.nodeId]
    badge.textContent = name || ""
    badge.classList.toggle("hidden", !name)
  }
}
